import { useAppSelector } from '@application/store/useStore';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
export default function CreditureTabsHelpers() {
    const { unchangedCreditor } = useAppSelector((state) => state.crediture);
    const [infoTabErrorBorderColor, setInfoTabErrorBorderColor] = useState(false);
    const [isInfoTabBold, setIsInfoTabBold] = useState(false);
    const [isNotesTabBold, setIsNotesTabBold] = useState(false);
    const [formdata, setFormData] = useState({
        id: 0,
        creditorNumber: 0,
        name: '',
        keywords: '',
        address: '',
        postalCode: '',
        city: '',
        country: '',
        phoneNumber: '',
        fax: '',
        email: '',
        website: '',
        poboxAddress: '',
        poboxPostalCode: '',
        poboxCity: '',
        poboxCountry: '',
        preference: false,
        orderEmail: '',
        internal: false,
        note: '',
        expired: false
    });
    const [errors, setErrors] = useState({
        creditorNumber: '',
        name: '',
        email: '',
        phoneNumber: '',
        poboxPostalCode: '',
        postalcode: '',
        orderEmail: ''
    });
    useEffect(() => {
        if (!errors.creditorNumber &&
            !errors.name &&
            !errors.email &&
            !errors.phoneNumber &&
            !errors.postalcode &&
            !errors.poboxPostalCode &&
            !errors.orderEmail) {
            setInfoTabErrorBorderColor(false);
        }
    }, [errors]);
    const handleFieldChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: ''
        }));
    };
    const handleToggelButtonChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
    };
    useEffect(() => {
        checkBoldFieldsCreditors();
        checkUnchangedFieldsCreditors();
    }, [formdata, unchangedCreditor]);
    const validateForm = () => {
        const newErrors = {
            creditorNumber: '',
            name: '',
            email: '',
            phoneNumber: '',
            poboxPostalCode: '',
            postalcode: '',
            orderEmail: ''
        };
        if (formdata.creditorNumber < 0) {
            newErrors.creditorNumber = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        if (formdata.name === null || formdata.name.trim() === '') {
            newErrors.name = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        if (formdata.email === null || formdata.email.trim() === '') {
            newErrors.email = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        else if (!/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/.test(formdata.email)) {
            newErrors.email = 'Ongeldig e-mailadres';
            setInfoTabErrorBorderColor(true);
        }
        if (formdata.phoneNumber === null || formdata.phoneNumber.trim() === '') {
            newErrors.phoneNumber = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        if (formdata.postalCode && formdata.postalCode?.length > 10) {
            newErrors.postalcode = 'Postcode mag niet langer zijn dan 10 tekens';
            setInfoTabErrorBorderColor(true);
        }
        if (formdata.poboxPostalCode && formdata.poboxPostalCode?.length > 10) {
            newErrors.poboxPostalCode = 'Postcode mag niet langer zijn dan 10 tekens';
            setInfoTabErrorBorderColor(true);
        }
        if (formdata.orderEmail && !/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/.test(formdata.orderEmail)) {
            newErrors.orderEmail = 'Ongeldig e-mailadres';
            setInfoTabErrorBorderColor(true);
        }
        setErrors(newErrors);
        return newErrors;
    };
    //---------------------Unsaved Functionality----------------------------
    const [isInfoTabUnsaved, setInfoTabUnsaved] = useState(false);
    const [isNotesTabUnsaved, setNotesTabUnsaved] = useState(false);
    const { id } = useParams();
    const checkUnchangedFieldsCreditors = () => {
        if (unchangedCreditor && formdata && id) {
            let isInfoTabUnsaved = false;
            let isNotitiesTabUnsaved = false;
            // Check for unsaved changes in the Info tab
            if (unchangedCreditor.creditorNumber !== formdata.creditorNumber ||
                unchangedCreditor.name !== formdata.name ||
                unchangedCreditor.email !== formdata.email ||
                unchangedCreditor.phoneNumber !== formdata.phoneNumber ||
                unchangedCreditor.address != formdata.address ||
                unchangedCreditor.postalCode != formdata.postalCode ||
                unchangedCreditor.city != formdata.city ||
                unchangedCreditor.country != formdata.country ||
                unchangedCreditor.website != formdata.website ||
                unchangedCreditor.fax != formdata.fax ||
                unchangedCreditor.poboxPostalCode != formdata.poboxPostalCode ||
                unchangedCreditor.orderEmail != formdata.orderEmail ||
                unchangedCreditor.preference != formdata.preference ||
                unchangedCreditor.expired != formdata.expired ||
                unchangedCreditor.internal != formdata.internal ||
                unchangedCreditor.keywords != formdata.keywords ||
                unchangedCreditor.website != formdata.website ||
                unchangedCreditor.fax != formdata.fax ||
                unchangedCreditor.poboxAddress != formdata.poboxAddress ||
                unchangedCreditor.poboxPostalCode != formdata.poboxPostalCode ||
                unchangedCreditor.poboxCity != formdata.poboxCity ||
                unchangedCreditor.poboxCountry != formdata.poboxCountry) {
                isInfoTabUnsaved = true;
            }
            // Check for unsaved changes in the Notes
            if (unchangedCreditor.note !== formdata.note) {
                isNotitiesTabUnsaved = true;
            }
            // Set unsaved state for all tabs
            setInfoTabUnsaved(isInfoTabUnsaved);
            setNotesTabUnsaved(isNotitiesTabUnsaved);
        }
    };
    const checkBoldFieldsCreditors = () => {
        if (formdata.creditorNumber || formdata.name || formdata.email || formdata.phoneNumber || formdata.address || formdata.postalCode || formdata.preference == true || formdata.expired == true
            || formdata.internal == true || formdata.city || formdata.country || formdata.keywords || formdata.orderEmail || formdata.website
            || formdata.fax || formdata.poboxAddress || formdata.poboxPostalCode || formdata.poboxCity || formdata.poboxCountry) {
            setIsInfoTabBold(true);
        }
        if (formdata.note) {
            setIsNotesTabBold(true);
        }
        else {
            setIsNotesTabBold(false);
        }
    };
    return {
        validateForm,
        formdata,
        errors,
        handleFieldChange,
        handleToggelButtonChange,
        setFormData,
        infoTabErrorBorderColor,
        isInfoTabUnsaved,
        isNotesTabUnsaved,
        isInfoTabBold,
        isNotesTabBold
    };
}
